
import { Component, Vue } from 'vue-property-decorator';
import Gravatar from 'vue-gravatar';
import { Action, State } from 'vuex-class';
import { UserInfo } from '@/types/user-info';
import { actions } from '@/store/types';

@Component({
    components: { Gravatar },
})
export default class TopAccountMenu extends Vue {
    @State('user')
    user!: UserInfo | null;

    @Action(actions.LOGOUT)
    logout!: () => void;

    get image() {
        return this.user?.profilePicture ? `data:image/png;base64,${this.user?.profilePicture}` : null;
    }

    get notifications() {
        return [
            // {
            //     avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
            //     title: '<b>User Unknown</b> accepted your <b>Sharing invite</b>',
            //     subtitle: '2h ago',
            //     online: true,
            // },
            // {
            //     avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
            //     title: '<b>Greg Campbell</b> added you as owner to Wolf’s bracelet <b>AirBolt</b>',
            //     subtitle: '4h ago',
            //     online: true,
            // },
            // {
            //     avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
            //     title: 'Your trial ends on August 24, 2020. Add your billing info to keep AirBolt Pro plan.',
            //     subtitle: '1d ago',
            //     online: false,
            // },
        ];
    }

    get hasNewNotifications() {
        return true;
    }
}
